//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  required,
} from 'vuelidate/lib/validators';
import ValidationMixin from '../../common/form/mixins/ValidationMixin';

export default {
  name: 'TextInput',
  mixins: [ValidationMixin],
  props: {
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: 'text input',
    },
    placeholder: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
  },
  validations: {
    value: {
      required,
    },
  },
  methods: {
    getErrors() {
      const errors = [];
      if (!this.$v.value.required) {
        errors.push( this.name + ' is required');
      }
      return errors;
    },
  },
};
